import { render, staticRenderFns } from "./PXSurveyEvaluationQuestionDetail.vue?vue&type=template&id=53db9b3c&scoped=true"
import script from "./PXSurveyEvaluationQuestionDetail.vue?vue&type=script&lang=js"
export * from "./PXSurveyEvaluationQuestionDetail.vue?vue&type=script&lang=js"
import style0 from "./PXSurveyEvaluationQuestionDetail.vue?vue&type=style&index=0&id=53db9b3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53db9b3c",
  null
  
)

export default component.exports